import { AlertVariant } from '@optimus-web/core';
import { HttpStatusCode, HttpStatusCodeGroup } from '@mews/enums';
import {
    LocalizedText,
    getHttpStatusCodeGroup,
    showErrorAlert,
    showInfoAlert,
    showSuccessAlert,
    showWarningAlert,
} from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

export const getServerNormalizedUrl = (
    routerBasePathRegex: RegExp,
    routerBaseUrl: string,
    serverBasePath: string,
    platformPrimaryUrl: string,
    url: string
) => {
    let normalizedUrl = url;
    /**
     * If the url matches an application format, we turn it into a server format
     */
    if (routerBasePathRegex.test(normalizedUrl)) {
        normalizedUrl = `${serverBasePath}${normalizedUrl.substring(routerBaseUrl.length)}`;
    }

    const serverUrl = `${platformPrimaryUrl}${normalizedUrl}`;
    return serverUrl;
};

export const getErrorTexts = (statusCode: number): { errorMessage: React.ReactNode; errorTitle: React.ReactNode } => {
    const statusGroup = getHttpStatusCodeGroup(statusCode);
    let errorMessage: React.ReactNode = <LocalizedText textKey={TextKey.GenericErrorMessage} />;
    let errorTitle: React.ReactNode = <LocalizedText textKey={TextKey.GenericErrorTitle} />;

    if (statusCode === HttpStatusCode.NotFound.value) {
        errorMessage = <LocalizedText textKey={TextKey.PageNotFoundErrorMessage} />;
        errorTitle = <LocalizedText textKey={TextKey.PageNotFoundTitle} />;
    } else if (statusCode === HttpStatusCode.BadGateway.value || statusCode === HttpStatusCode.Timeout.value) {
        errorMessage = <LocalizedText textKey={TextKey.PageTimeoutErrorMessage} />;
        errorTitle = <LocalizedText textKey={TextKey.PageTimeoutTitle} />;
    }

    if (statusGroup === HttpStatusCodeGroup.ClientErrors) {
        errorMessage = null;
    }

    return {
        errorTitle,
        errorMessage,
    };
};

export const getStacktraceFromErrorTemplate = (data: string) => {
    const parser = new window.DOMParser();
    const htmlDoc = parser.parseFromString(data, 'text/html');
    const stackTraceElement = htmlDoc.getElementsByTagName('pre')[0];
    return stackTraceElement ? stackTraceElement.innerHTML : null;
};

export type ApiGeneratedAlertType = `${Capitalize<AlertVariant>}`;

interface ShowAlertOptions {
    message: string;
    type: ApiGeneratedAlertType;
}

/* Use only in TemplateFetcher/BE legacy content! */
export const showAlert = ({ message, type }: ShowAlertOptions) => {
    const props = { description: <>{message}</> };
    switch (type) {
        case 'Error':
            showErrorAlert(props);
            break;
        case 'Success':
            showSuccessAlert(props);
            break;
        case 'Warning':
            showWarningAlert(props);
            break;
        default:
            showInfoAlert(props);
    }
};
